module.exports = __webpack_public_path__ + "static/media/not-found.2f302b1d.svg";